import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Slider,
} from '@mui/material';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import getCroppedImg from './cropImage';

export default function AvatarCropperDialog({ open, image, onCancel, onSave }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleCropComplete = useCallback((_croppedArea, pixels) => {
    setCroppedAreaPixels(pixels);
  }, []);

  const handleExited = () => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const handleConfirm = async () => {
    if (!croppedAreaPixels) return;
    setSaving(true);
    try {
      const dataUrl = await getCroppedImg(image, croppedAreaPixels);
      onSave(dataUrl);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth TransitionProps={{ onExited: handleExited }}>
      <DialogTitle>ปรับตำแหน่งรูปภาพ</DialogTitle>
      <DialogContent>
        <Box sx={{ position: 'relative', width: '100%', height: 300, bgcolor: '#222', borderRadius: 1, overflow: 'hidden' }}>
          {image && (
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={handleCropComplete}
            />
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 2, px: 0.5 }}>
          <ZoomOutIcon fontSize="small" color="action" />
          <Slider
            value={zoom}
            min={1}
            max={3}
            step={0.01}
            onChange={(e, v) => setZoom(v)}
            size="small"
          />
          <ZoomInIcon fontSize="small" color="action" />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} variant="contained" disabled={saving || !croppedAreaPixels}>
          ตกลง
        </Button>
        <Button onClick={onCancel} variant="outlined">ยกเลิก</Button>
      </DialogActions>
    </Dialog>
  );
}

AvatarCropperDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  image: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

AvatarCropperDialog.defaultProps = {
  image: null,
};
